import React from "react";
import FormInf from "../FormInf/FormInf";
import { Segmented } from "antd";
import FormTree from "../FormTree/FormTree";
import FormInputs from "../FormInputs/FormInputs";
import trans, { isRTL } from "../../../../utils";

export default function FormSections({
	collapsed,
	items,
	setActiveInput,
	setActive,
	disableDrop,
	addForm,
	containerKey,
	activeOption,
	setActiveOption,
	setDirection,
	direction,
}) {
	return (
		<div
			className="task-inputs-layout"
			style={{
				width: !collapsed.inputsCollapsed ? "24%" : "0%",
				padding: !collapsed.inputsCollapsed ? "16px" : "0%",
			}}
			dir={isRTL ? "rtl" : "ltr"}
		>
			<Segmented
				options={[
					{ label: trans("Main"), value: "Main" },
					{ label: trans("Fields"), value: "Fields" },
					{ label: trans("Form Tree"), value: "Form Tree" },
				]}
				onChange={(value) => {
					setActiveOption(value);
				}}
				value={activeOption}
				className="mb-3"
				block
			/>

			{activeOption === "Fields" && (
				<FormInputs disableDrop={disableDrop} collapsed={collapsed} />
			)}
			{activeOption === "Main" && (
				<FormInf
					collapsed={collapsed}
					addForm={addForm}
					direction={direction}
					setDirection={setDirection}
				/>
			)}
			{activeOption === "Form Tree" && (
				<FormTree
					collapsed={collapsed}
					items={items}
					setActiveInput={setActiveInput}
					setActive={setActive}
				/>
			)}
		</div>
	);
}
